module.exports = __webpack_public_path__ + "static/media/97.b5ee51da.png";